import { Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { takeUntil } from 'rxjs/operators';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-assist-list',
  templateUrl: './assist-list.component.html',
  styleUrls: ['./assist-list.component.css']
})
export class AssistListComponent implements OnInit {
  user: any;
  timeZone: any;
  buckAttendeeList = [];
  predriverList = {};
  drivers;
  search;
  status = 'active';
  selectedDriver = [];
  filteredBucksList = [];



  constructor(
    private assistService : AssistService,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
  ) { }

  ngOnInit() {
    this.getBuckAttendee();
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          this.getDriverList();
        }
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, '')
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          const buckDriverIds = this.buckAttendeeList.map(buck => buck.driver);
          this.predriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.drivers = data.filter(driver => buckDriverIds.includes(driver._id));
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  getBuckAttendee() {
    this.assistService
      .getBuckAttendee()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.buckAttendeeList = data;
          this.filterBucksByDriver();
          this.getDriverList();
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  filterBucksByDriver() {
    if (this.selectedDriver.length === 0) {
      this.filteredBucksList = this.buckAttendeeList;
    } else {
      this.filteredBucksList = this.buckAttendeeList.filter(buck =>
        this.selectedDriver.includes(buck.driver)
      );
    }
  }

  filterTripsByModel() {
    this.filterBucksByDriver();
  }

  ngOnDestroy(): void {
  }

}
